<template>
  <div class="container">
    <div class="oneBox">
      <div class="pos">
        <div class="titleBox">
          <h3>华晟健康管理运营平台—E晟宝系统</h3>
          <p>基于“健康云”服务概念，为各级医疗机构、社会、企业及民众提供远程健康管理的信息化服务平台。</p>
          <p>帮助合作企业高效快捷的追踪检测状态信息，打破原有的线下服务营销模式用全新的信息化营销概念，提升客户体验，让服务更贴心，合作更高效！</p>
        </div>
        <div class="imgBox">
          <img src="../../../../assets/EStu1.png" alt="" style="width:971px;height:542px;">
          <div class="shadowBox">
            <div class="titleBoxa">
              <p>实现“自我管理、评估指导、友情关爱、提醒干预”的整体健康管理服务流程</p>
            </div>
            <div class="bottomBoxa">
              <div class="bottomBoxa-1">
                <h3>健康运营</h3>
                <p>打通了一个体检的流程，机构用户如保险，证券等，业</p>
                <p>务员，护士等可以登陆系统完成业务操作。</p>
              </div>
              <div class="bottomBoxa-1">
                <h3>健康管理</h3>
                <p>打通了一个用户从录入健康档案到健康咨询，健康管理</p>
                <p>的流程。</p>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="twoBox">
      <div class="pos">
        <div class="title">
          <h3>协助企业与客户搭建桥梁</h3>
        </div>
        <div class="bottom">
          <div class="bottom-1">
            <div class="bottom-once">
              <img src="../../../../assets/EStu2.png" alt="">
              <span>定制个人健康管理方案</span>
            </div>
            <div class="bottom-once">
              <img src="../../../../assets/EStu3.png" alt="">
              <span>专业服务，赢得客户信任与口碑</span>
            </div>
            <div class="bottom-once">
              <img src="../../../../assets/EStu4.png" alt="">
              <span>建立健康档案及风险评估</span>
            </div>
          </div>
          <div class="bottom-1">
            <div class="bottom-once">
              <img src="../../../../assets/EStu5.png" alt="">
              <span>连接三甲医院的诊疗资源和专家报告解读</span>
            </div>
            <div class="bottom-once">
              <img src="../../../../assets/EStu6.png" alt="">
              <span>轻松邀约，完美对接营销平台</span>
            </div>
            <div class="bottom-once">
              <img src="../../../../assets/EStu7.png" alt="">
              <span>化身客户的家庭健康大使，增加客户粘度</span>
            </div>
          </div>
          <div class="bottom-3">
            <img src="../../../../assets/ESerweima.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {}
}
</script>

<style scoped lang="scss">
.container {
  .oneBox {
    width: 100%;
    height: 838px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('../../../../assets/ESbgc.png') no-repeat;
    margin-top: 84px;
    .pos {
      width: 1321px;
      height: 706px;
      // border: 1px solid red;
      text-align: center;
      .titleBox {
        h3 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 104, 183, 1);
          line-height: 36px;
          margin-bottom: 18px;
        }
        p {
          font-size: 20px;
          font-family: Microsoft YaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 37px;
        }
      }
      .imgBox {
        width: 100%;
        height: 542px;
        margin-top: 58px;
        position: relative;
        img {
        }
        .shadowBox {
          width: 971px;
          height: 160px;
          background: rgba(0, 0, 0, 1);
          opacity: 0.8;
          margin-left: 175px;
          padding: 19px 41px 18px 23px;
          box-sizing: border-box;
          position: absolute;
          bottom: 0;
          .titleBoxa {
            width: 100%;
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255, 254, 254, 1);
            p {
              text-align: left;
            }
          }
          .bottomBoxa {
            display: flex;
            justify-content: space-between;
            margin-top: 22px;
            .bottomBoxa-1 {
              text-align: left;
              border-right: 1px solid #0068b7;
              &:nth-child(1) {
                width: 452px;
              }
              &:nth-child(2) {
                border: none;
              }
              h3 {
                font-size: 22px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(0, 104, 183, 1);
                margin-bottom: 8px;
              }
              p {
                font-size: 17px;
                font-family: Microsoft YaHei;
                font-weight: 300;
                color: rgba(255, 255, 255, 1);
                line-height: 25px;
              }
            }
          }
        }
      }
    }
  }
  .twoBox {
    width: 100%;
    height: 730px;
    background-color: #f1f6f7;
    display: flex;
    justify-content: center;
    align-items: center;
    .pos {
      width: 1371px;
      height: 441px;
      // border: 1px solid red;
      .title {
        width: 100%;
        text-align: center;
        margin-bottom: 112px;
        h3 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 104, 183, 1);
          line-height: 48px;
        }
      }
      .bottom {
        width: 100%;
        height: 249px;
        // border: 1px solid red;
        display: flex;
        justify-content: space-around;
        .bottom-1 {
          .bottom-once {
            margin-bottom: 60px;
            img {
              vertical-align: middle;
              margin-right: 15px;
            }
            span {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: rgba(51, 51, 51, 1);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/product/component/esheng.vue